import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    affiliate: {
      affiliate_api: {
        header: 'HEADER',
        copy: 'COPY',
        link: 'LINK',
        reset_api_token_button: 'RESET_BTN',
        confirm_reset_api_token_modal: {
          title: 'TITLE',
          question: 'QUESTION',
          answer_yes: 'ANSWER_YES',
          answer_no: 'ANSWER_NO',
        },
      },
    },
  }));
}
